import Fab from '@material-ui/core/Fab'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import ForumIcon from '@material-ui/icons/ForumOutlined'
import { withStyles } from '@material-ui/styles'
import React, { Component } from 'react'
import { getEMPI, getEnrolledMemberData, getMyneedsEOS } from '../ApiCall'
import apiService from '../../utils/apiservice'
import CommonLoader from '../CommonLoader'
import CommonFooter from './CommonFooter'
import DataTable from './DataTable'
import DataTableNew from './DataTableNew'
import Header from './Header'
import './MyNeeds.css'
import { AppBar, Box, Tab, Tabs, Tooltip, Typography } from '@material-ui/core'
import customStyle from './programInfo/CSS/stylesheet_UHS.js'
import ContributionDataTable from './ContributionDataTable'
import ReimbursementDataTable from './ReimbursementDataTable'
import MessageCard from './MessageCard'
import { loadPluginScript } from '../pluginLoader'
import { startSession } from '../../actions/homeActions'
const AntTabs = withStyles(customStyle.MyneedsTabs)(Tabs)

const CrudButton = withStyles(customStyle.crudBtn)(Fab)
export default class MyNeeds extends Component {
  constructor(props) {
    super(props)
    const isReimbursementOnly = this.props.forceReimbursementOnly || false
    this.state = {
      tableData: [],
      loader: !isReimbursementOnly, // If only showing reimbursements, drop initial needs loaders,
      notfoundmsg1: '',
      notfoundmsg2: '',
      notfoundmsg3: '',
      open: false,
      tabEnable: localStorage.getItem('isAdmin') ? true : false,
      selectedTab: isReimbursementOnly ? 'MyReimbursementRequests' : 'MyShareRequests',
      showReimbursementFormInTab: false,
      selectedRowData: null,
      familyMembers: [],
      isReimbursementFlow: false,
      files: [],
      enrolledDataMember: []
    }
  }

  componentDidMount() {
    // Store the initial URL state to track changes later
    sessionStorage.setItem('processed_reimbursement_url', window.location.href)
    // Maintain core server session setup parameters
    startSession().then(res => {
      this.initializeReimbursementData()
    })

    window.addEventListener('message', this.handleReimbursementComplete)
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  componentWillUnmount() {
    // Clean up event listener
    window.removeEventListener('message', this.handleReimbursementComplete)
    // Cleanup plugin on unmount
    if (window.closeCommonPluginScreen) {
      window.closeCommonPluginScreen()
    }
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
  }

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location || this.props.forceReimbursementOnly) {
      let currentUrl = window.location.href
      let fallbackTrack = sessionStorage.getItem('processed_reimbursement_url')

      if (currentUrl !== fallbackTrack && currentUrl.includes('state=')) {
        sessionStorage.setItem('processed_reimbursement_url', currentUrl)
        console.log('[MyNeeds] URL mutation detected. Parsing new token profile data...')

        this.setState({ loader: true }, () => {
          this.initializeReimbursementData()
        })
      }
    }
  }

  initializeReimbursementData = () => {
    const isReimbursementOnly = this.props.forceReimbursementOnly || false

    if (isReimbursementOnly) {
      console.log('Forced reimbursement mode active via routing configuration.')
      // 1. STRATEGY A: Check if CustomAuth safely injected decrypted profile data into router memory
      const routerState = this.props.location?.state
      if (routerState && routerState.decryptedProfile) {
        console.log('Successfully extracted profile record from Router history memory state:', routerState.decryptedProfile)

        const memberRecord = routerState.decryptedProfile
        this.setStorageItem('userMail', this.getStorageItem('userMail') || '')

        this.setState({
          memberData: memberRecord,
          loader: false,
          selectedTab: 'MyReimbursementRequests',
          showReimbursementFormInTab: false
        })
        return
      }
      let url = window.location.href

      // Parse from either standard query string (?) or hash string (#)
      let queryString = ''
      if (url.split('?').length > 1) {
        queryString = url.split('?')[1]
      } else if (url.split('#').length > 1) {
        queryString = url.split('#')[1]
      }

      let queryParams = new URLSearchParams(queryString)

      if (queryParams.has('state')) {
        try {
          let getState = decodeURIComponent(queryParams.get('state'))
          let decodedData = {}

          // Safety checks to handle native Base64 JSON strings or pure encrypted hashes
          if (!getState.startsWith('{') && !getState.includes('"')) {
            decodedData = JSON.parse(atob(getState))
          } else {
            decodedData = JSON.parse(getState)
          }

          console.log('Successfully extracted state profile data:', decodedData)
          this.setStorageItem('userMail', decodedData.userMail || '')

          this.setState({
            memberData: decodedData,
            loader: false,
            selectedTab: 'MyReimbursementRequests',
            showReimbursementFormInTab: false
          })
        } catch (error) {
          console.error('State data decoding failure:', error)
          this.setState({ loader: false })
        }
      } else {
        this.setState({ loader: false })
        console.log('No deep links found. Fetching via API context...')
        this.getEMPID()
      }
    } else {
      this.getEMPID()
    }
  }

  handleReimbursementComplete = event => {
    // Check if the message is from the reimbursement iframe
    if (event.data?.type === 'memberReimbursementRequestComplete') {
      const eventData = event.data?.data || {}

      // Check if the event contains error information
      if (event.data?.error || event.data?.status === 'error') {
        console.error('Reimbursement request error:', eventData)
        // Handle error case - perform back button function
        this.goBack()
      } else {
        // Handle success case - perform back button function
        console.log('Reimbursement request completed successfully:', eventData)
        this.goBack()
      }
    }
  }

  getEMPID() {
    getEMPI().then(res => {
      this.myneedsEOS()
    })
    // this.setState({tableData: arrayNeeds, loader: false})
  }

  getEnrolledMember = async () => {
    try {
      const res = await getEnrolledMemberData()

      if (res && res.data) {
        this.setState({
          enrolledDataMember: res.data
        })

        return res.data
      }

      return []
    } catch (error) {
      console.log(error)
      return []
    }
  }

  getFamilyMembers = async () => {
    let email = this.getStorageItem('userMail')

    if (!email) {
      console.log('Email not found in localStorage')
      return []
    }

    try {
      const enrolledDataMember = await this.getEnrolledMember()
      if (enrolledDataMember && Array.isArray(enrolledDataMember)) {
        return enrolledDataMember.map(member => {
          return {
            memberId: localStorage.getItem('SOURCE') === 'NEO' ? member.memberIdSource : member.memberId,
            firstName: member.firstName || '',
            middleName: member.middleName || '',
            lastName: member.lastName || '',
            prefix: member.prefix || '',
            suffix: member.suffix || '',
            fullName: `${member.prefix || ''} ${member.firstName || ''} ${member.middleName || ''} ${member.lastName ||
              ''} ${member.suffix || ''}`
              .trim()
              .replace(/\s+/g, ' '),
            status: member?.status || '',
            benefitEnd: member?.benefits?.[0]?.benefitEnd || ''
          }
        })
      }

      return []
    } catch (err) {
      console.error('Error fetching family members:', err)
      return []
    }
  }

  myneedsEOS = () => {
    getMyneedsEOS()
      .then(res => {
        if (res.data && res.data.length > 0) {
          this.setState({ tableData: res.data, loader: false })
        } else {
          this.setState({
            notfoundmsg1:
              'No needs have been entered into the system.Submitted needs may take 2-3 days to be displayed here.For any clarifications call Customer Service.',
            loader: false
          })
        }
      })
      .catch(err => {
        this.setState({ loader: false })
      })
  }

  goBack = () => {
    if (this.state.showReimbursementFormInTab) {
      const container = document.getElementById('reimbursement-plugin-container')

      if (container) {
        container.innerHTML = ''
      }

      if (window.closeCommonPluginScreen) {
        window.closeCommonPluginScreen()
      }

      this.setState({
        showReimbursementFormInTab: false,
        selectedTab: 'MyReimbursementRequests',
        selectedRowData: null
      })

      return
    }
    const isReimbursementOnly = this.props.forceReimbursementOnly || false

    if (!isReimbursementOnly) {
      this.props.history.push('/')
    } else {
      return
    }
  }

  getMemberData = () => {
    return {
      phone: localStorage.getItem('phone') || '',
      email: sessionStorage.getItem('userMail') || localStorage.getItem('userMail') || '',
      initiatedUser: localStorage.getItem('initiatedUser') || localStorage.getItem('userMail') || '',
      source: localStorage.getItem('isServiceCloud') ? 'ServiceCloud' : 'MemberPortal',
      userRole: localStorage.getItem('isServiceCloud') ? 'ServiceCloud' : 'USER',
      type: 'reimbursement',
      client: 'UHF',
      memberName: sessionStorage.getItem('subscriberName') || localStorage.getItem('subscriberName') || '',
      requestId: this.state.selectedRowData?.id || '',
      planId: localStorage.getItem('planId') || '',
      memberId: localStorage.getItem('EMPID') || '',
      memberSSN: localStorage.getItem('memberSSN') || '',
      clientId: localStorage.getItem('CLIENT_ID') || ''
    }
  }

  openReimbursementForm = async (rowData = null) => {
    window.scrollTo(0, 0)

    try {
      // 1. Fetch any async dependecies (like family lists) and wait for the plugin script
      const [familyMembers] = await Promise.all([
        this.getFamilyMembers(),
        loadPluginScript() // Ensures window.loadCommonPluginScreen exists
      ])

      // 2. Set state to paint your matching <div id="reimbursement-plugin-container" />
      this.setState(
        {
          selectedTab: 'MyReimbursementRequests',
          showReimbursementFormInTab: true,
          selectedRowData: rowData
        },
        () => {
          // 3. Construct the clean config wrapper expected by <PluginApp />
          const config = {
            ...this.getMemberData(), // Pulls phone, email, type, client, memberId, etc.
            familyMembers: familyMembers || [],
            token: localStorage.getItem('token') || '',
            onComplete: eventPayload => {
              console.log('Reimbursement payload received:', eventPayload)
              this.goBack()
            }
          }

          const container = document.getElementById('reimbursement-plugin-container')

          if (container && typeof window.loadCommonPluginScreen === 'function') {
            // Pass your application layout ID ('838') and your final config schema
            window.loadCommonPluginScreen('838', config)
          } else {
            console.error('Target container wrapper node or setup script initialization failed.')
          }
        }
      )
    } catch (error) {
      console.error('Could not spin up the common reimbursement form:', error)
    }
  }
  getTabConfig = () => {
    const source = localStorage.getItem('SOURCE');

    if (this.props.forceReimbursementOnly) {
      return source === 'NEO'
        ? [{ label: 'MY REIMBURSEMENT REQUESTS', value: 'MyReimbursementRequests' }]
        : [];
    }

    const commonTabs = [
      { label: 'MY NEEDS', value: 'MyShareRequests' },
      { label: 'MY REIMBURSEMENT REQUESTS', value: 'MyReimbursementRequests' }
    ];

    const adminTabs = [
      { label: 'MY NEEDS', value: 'MyShareRequests' },
      { label: 'MY CONTRIBUTIONS', value: 'MyCONTRIBUTIONS' },
      { label: 'MY REIMBURSEMENT REQUESTS', value: 'MyReimbursementRequests' }
    ];

    const tabs = this.state.tabEnable ? adminTabs : commonTabs;

    return source !== 'NEO'
      ? tabs
      : tabs.filter(tab => tab.value !== 'MyReimbursementRequests');
  };

  isReimbursementSession = () => {
    return this.props.forceReimbursementOnly || false
  }

  getStorage = () => {
    return this.isReimbursementSession() ? sessionStorage : localStorage
  }

  setStorageItem = (key, value) => {
    this.getStorage().setItem(key, value)
  }

  getStorageItem = key => {
    return this.getStorage().getItem(key)
  }

  renderTabs = () => {
    const tabs = this.getTabConfig()
    const tabStyle = {
      textTransform: 'capitalize',
      marginTop: 10,
      fontSize: 24
    }

    return (
      <>
      { localStorage.getItem('SOURCE') === 'NEO' && !this.state.tabEnable ?  
      <Box component="section" sx={{ p: 4, borderRadius: 1 }}>
                <Typography
                  variant="h3"
                  style={{
                    fontWeight: 300,
                    color: '#333',
                    textTransform: 'uppercase',
                  }}
                >
                  My Needs
                </Typography>
              </Box>
      : <AntTabs
        value={this.state.selectedTab}
        onChange={(e, newValue) => this.setState({ selectedTab: newValue })}
        textColor="#33333"
        indicatorColor="secondary"
        aria-label="secondary tabs example"
        variant="fullWidth"
        id="tabs"
        style={{ width: '100%' }}
      >
        {tabs.map(tab => (
          <Tab
            key={tab.value}
            label={tab.label}
            value={tab.value}
            style={{
              ...tabStyle,
              width: '13%',
              color: this.state.selectedTab === tab.value ? '#000' : '#7e7e7e'
            }}
          />
        ))}
      </AntTabs>}
      </>
    )
  }

  render() {
    const { tableData } = this.state
    const isReimbursementOnly = this.props.forceReimbursementOnly || false

    if (isReimbursementOnly) {
      return (
        <div
          className="isolated-reimbursement-view"
          style={{
            position: 'absolute', // Absolute lets it fill the frame cleanly if inside an iframe
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            minHeight: '100vh', // Falls back to full viewport height if the iframe container expands
            background: '#ffffff',
            display: 'flex',
            flexDirection: 'column',
            boxSizing: 'border-box'
          }}
        >
          {this.state.loader && <CommonLoader />}

         {localStorage.getItem('SOURCE') !== 'NEO' && 
          <AppBar position="static" style={{ backgroundColor: '#2e3192', flexShrink: 0 }}>
            <div style={{ margin: '10px' }}>
              <Typography variant="h6" component="div" style={{ flexGrow: 1 }}>
                <span
                  className="Back_page"
                  style={{ color: 'white', width: '100%', cursor: 'pointer', display: 'flex', alignItems: 'center' }}
                  aria-disabled={this.state.showReimbursementFormInTab}
                  onClick={this.goBack}
                >
                  {this.state.showReimbursementFormInTab && (
                    <Tooltip title="Go Back" arrow>
                      <ArrowBackIcon
                        style={{
                          width: '24px',
                          height: '24px',
                          marginRight: '5px'
                        }}
                      />
                    </Tooltip>
                  )}
                  Reimbursement Request
                </span>
              </Typography>
            </div>
          </AppBar>}

          {/* Dynamic layout engine: takes up all remaining vertical space beneath the header */}
          <div
            style={{
              flexGrow: 1,
              width: '100%',
              position: 'relative',
              display: 'flex',
              flexDirection: 'column',
              overflow: 'hidden' // Keeps iframe window contents from spilling out
            }}
          >
            {this.state.showReimbursementFormInTab ? (
              <div
                id="reimbursement-plugin-container"
                style={{
                  width: '100%',
                  height: '100%',
                  flexGrow: 1,
                  background: '#ffffff',
                  overflowY: 'auto',
                  WebkitOverflowScrolling: 'touch' // Smooth momentum scrolling for mobile safari/iframes
                }}
              />
            ) : (
              <div
                className="isolated-table-wrapper"
                style={{
                  padding: '20px',
                  flexGrow: 1,
                  display: 'flex',
                  flexDirection: 'column',
                  boxSizing: 'border-box',
                  overflowY: 'auto'
                }}
              >
                <div style={{ flexGrow: 1, overflowY: 'auto' }}>
                  <ReimbursementDataTable
                    tableData={this.state.memberData ? [this.state.memberData] : []}
                    onUpdateClick={rowData => this.openReimbursementForm(rowData)}
                    forceReimbursementOnly={true}
                  />
                </div>

                <div className="progInfoFooter" style={{ flexShrink: 0, paddingTop: '10px' }}>
                  <div className="row">
                    <div className="col-md-8 myNeedsFooterActionCol">
                      <button type="button" className="myNeedsReimbursementBtn" onClick={() => this.openReimbursementForm(null)}>
                        REIMBURSEMENT REQUEST
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      )
    }

    return (
      <div className="progInfoMainWrapper" style={{ backgroundColor: '#E4EFFC' }}>
        <Header name={'MyNeeds'} />
        {this.state.loader ? <CommonLoader /> : null}
        <div className="container progInfoContainer" style={{ zIndex: '0' }}>
          <span className="Back_page" onClick={this.goBack}>
            <ArrowBackIcon
              style={{
                width: '24px',
                height: '24px',
                color: '#2e3192',
                marginRight: '5px'
              }}
            />
            BACK
          </span>

          <div className="commonWrap_MyNeeds" style={{ marginTop: '15px' }}>
            {this.state.showReimbursementFormInTab ? (
              <div
                id="reimbursement-plugin-container"
                style={{
                  width: '100%',
                  minHeight: '400px'
                }}
              />
            ) : (
              <>
                {!this.state.tabEnable && (
                  <div className="progInfoSection" style={{ marginBottom: '-20px' }}>
                    {this.renderTabs()}
                  </div>
                )}
                {this.state.tabEnable && this.renderTabs()}
                <div>
                  {this.state.selectedTab === 'MyShareRequests' && (
                    <div className="tablebackgroundouter">
                      {this.state.tableData && this.state.tableData.length > 0 ? (
                        this.state.tabEnable ? (
                          <DataTableNew setLoader={(val) =>  this.setState({ loader: val })} open={this.state.open} tableData={this.state.tableData} />
                        ) : (
                          <DataTable setLoader={(val) =>  this.setState({ loader: val })} open={this.state.open} tableData={this.state.tableData} />
                        )
                      ) : (
                        <div className="data_not_found">{this.state.notfoundmsg1 && <MessageCard message={this.state.notfoundmsg1} />}</div>
                      )}
                    </div>
                  )}

                  {this.state.selectedTab === 'MyReimbursementRequests' && localStorage.getItem('SOURCE') !== 'NEO' && (
                    <div className="tablebackgroundouter">
                      <ReimbursementDataTable
                        tableData={this.state.memberData ? [this.state.memberData] : []}
                        onUpdateClick={rowData => this.openReimbursementForm(rowData)}
                      />
                    </div>
                  )}

                  {this.state.tabEnable && this.state.selectedTab === 'MyCONTRIBUTIONS' && (
                    <div className="tablebackgroundouter">
                      <ContributionDataTable />
                    </div>
                  )}

                  {localStorage.getItem('SOURCE') !== 'NEO' && 
                  <div className="progInfoFooter">
                    <div className="row">
                      <div className="col-md-8 myNeedsFooterActionCol">
                        <button type="button" className="myNeedsReimbursementBtn" onClick={this.openReimbursementForm}>
                          REIMBURSEMENT REQUEST
                        </button>
                      </div>
                    </div>
                  </div>}
                </div>
              </>
            )}
          </div>
        </div>

        {/* Floating Chat Button */}
        <CrudButton
          className={'purechat-button-expand'}
          color="primary"
          onClick={() => window.pureChat()}
          aria-label="chat"
          title="Chat with a Universal Health Fellowship Representative"
          style={{
            width: '65px',
            height: '65px',
            backgroundColor: '#ed1c24',
            color: '#ffffff',
            borderRadius: '50%',
            border: 'none',
            position: 'fixed',
            right: '20px',
            bottom: '100px',
            zIndex: 109
          }}
        >
          <ForumIcon />
        </CrudButton>

        <div style={{ paddingTop: '23vh' }}>
          <CommonFooter />
        </div>
      </div>
    )
  }

  openChat = () => {
    sessionStorage.setItem('chatwindow', true)
    this.props.history.push('/')
  }
}
